import { buildApiUrl, getUserId } from '../../configs/api.js'

export default {
  url({ id, type }) {
    // Dans l'API v3, on récupère le balance globalement pour l'utilisateur
    // Pour l'admin, on utilise /api/wallet (qui renvoie le solde principal)
    return buildApiUrl('/wallet', {
      userId: id || getUserId()
    })
  },
  parse(raw = {}, payload = { type: '' }) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        data: { balance: '0' },
        currency: 'XOF',
      }
    }

    return {
      statusCode: 200,
      data: { balance: raw.data?.balance || '0' },
      currency: raw.data?.currency || 'XOF',
    }
  },
}
